<template>
  <div class="header">
    <img src="../../src/assets/images/topBanner.png" alt="" />
    <div class="headerMenuBox">
      <div class="headerMenuList">
        <div v-for="(item, ind) in menuList" :key="ind" :class="['headerMenuItem', curMenu === ind ? 'active' : '']"
          @click="headerMenuClick(item)">
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="navBox">
      当前位置：
      <span style="cursor: pointer" @click="routerChick">王阶全国名中医传承工作室</span>
      <span v-if="curMenu > 1">＞</span><span v-if="curMenu > 1" style="cursor: pointer" @click="secondRouterChick">{{
        currentRouterName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalHeader",
  data() {
    return {
      curMenu: 0,
      currentRouter: {},
      allMenuList: [
        {
          label: "网站首页",
          value: "0",
          path: "/index",
          show: false
        },
        {
          label: "网站首页",
          value: "0",
          path: "/topic",
          show: true
        },
        {
          label: "个人简介",
          value: "1",
          path: "/personInfo",
          show: true
        },
        {
          label: "工作室介绍",
          value: "2",
          path: "/studio",
          show: true
        },
        {
          label: "成员简介",
          value: "3",
          path: "/memberInfo",
          show: true
        },
        {
          label: "成员详情",
          value: "3",
          path: "/memberDetail",
          show: false
        },
        {
          label: "弟子业绩",
          value: "4",
          path: "/pupil",
          show: true
        },
        {
          label: "弟子业绩详情",
          value: "4",
          path: "/pupilDetail",
          show: false
        },
        {
          label: "经验总结",
          value: "5",
          path: "/exp",
          show: true
        },
        {
          label: "经验总结详情",
          value: "5",
          path: "/expDetail",
          show: false
        },
        {
          label: "典型病案",
          value: "6",
          path: "/case",
          show: true
        },
        {
          label: "典型病案详情",
          value: "6",
          path: "/caseDetail",
          show: false
        },
        {
          label: "学术成就",
          value: "7",
          path: "/achieve",
          show: true
        },
        {
          label: "学术成就详情",
          value: "7",
          path: "/achieveDetail",
          show: false
        },
        {
          label: "人才培养",
          value: "8",
          path: "/talent",
          show: false
        },
        {
          label: "人才培养详情",
          value: "8",
          path: "/talentDetail",
          show: false
        },
        {
          label: "工作室新闻动态",
          value: "9",
          path: "/news",
          show: false
        },
        {
          label: "工作室新闻动态详情",
          value: "9",
          path: "/newsDetail",
          show: false
        },
        {
          label: "媒体报道",
          value: "10",
          path: "/media",
          show: false
        },
        {
          label: "科普园地",
          value: "11",
          path: "/science",
          show: false
        },
        {
          label: "视频专栏",
          value: "12",
          path: "/video",
          show: false
        }
      ],
      menuList: [],
      currentRouterName: "",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop, true);

  },
  created() {
    this.menuList = this.allMenuList.filter(item => item.show)
    console.log(this.menuList)
  },
  watch: {
    $route: {
      // $route可以用引号，也可以不用引号  监听的对象
      handler(to, from) {
        console.log("上一个路由：" + from);
        this.curMenu = Number(
          this.allMenuList.find((item) => item.path === to.path).value
        );
        this.currentRouterName = JSON.parse(
          localStorage.getItem("currentRouter")
        ).name;
        this.currentRouter = JSON.parse(localStorage.getItem("currentRouter"));
        if (this.currentRouter.path !== to.path) {
          this.$router.push({
            path: to.path,
            query: {},
          });
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 50) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    headerMenuClick(item) {
      // if (item.value === '0') {
      //   window.open('https://www.gamyy.cn/', '_blank');
      // } else {
        this.currentRouter = JSON.parse(localStorage.getItem("currentRouter"));
        if (this.currentRouter.path !== item.path) {
          this.$router.push({
            path: item.path,
            query: {},
          });
        }
        this.curMenu = Number(item.value);
      // }

    },
    routerChick() {
      this.currentRouter = JSON.parse(localStorage.getItem("currentRouter"));
      if (this.currentRouter.path !== "/topic") {
        this.$router.push({
          path: "/topic",
          query: {},
        });
      }
    },
    secondRouterChick() { },
  },
};
</script>

<style>
.header {
  /* width: 100%;
  height: 400px;
  background: url('../../src/assets/images/topBanner.png') no-repeat;
  background-size: cover; */
}

.header img {
  width: 100%;
}

.headerMenuBox {
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  background: url("../../src/assets/images/menuBac.png") no-repeat;
  background-size: cover;
}

.headerMenuList {
  width: 1200px;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-around;
}

.headerMenuItem {
  width: 112px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff5ea;
  cursor: pointer;
  line-height: 48px;
  text-align: center;
}

.headerMenuItem.active {
  background: url("../../src/assets/images/activeMenu.png") no-repeat;
  background-size: cover;
  height: 54px;
  margin-top: -6px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.navBox {
  width: 1200px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #391603;
  line-height: 16px;
  margin: 24px auto 66px;
}
</style>
